import { render, staticRenderFns } from "./AssessmentsListingBody.vue?vue&type=template&id=c1292082&scoped=true&"
import script from "./AssessmentsListingBody.vue?vue&type=script&lang=ts&"
export * from "./AssessmentsListingBody.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentsListingBody.vue?vue&type=style&index=0&id=c1292082&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1292082",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VIcon,VImg,VPagination,VRow})
